// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__23nV6","content":"GlobalSearch_content__3Nc5F"};